<template>
    <StyleHorary>
        <div class="modal-delivery-time-header">
            <h2>Escolha seu horário</h2>
        </div>
        <ul>
            <li
                v-for="dt in delivery_times"
                :key="dt.id"
                @click="handleSelectDeliveryTime(dt)"
            >
                <div class="checkbox">
                    <i v-if="dt.checked" class="fas fa-check"></i>
                </div>
                <span> {{ dt.start_time }} às {{ dt.end_time }} </span>
            </li>
        </ul>
        <div class="modal-delivery-time-footer">
            <CancelButton type="button" @click.prevent="handleCancel">
                Cancelar
            </CancelButton>
            <PrimaryButton type="button" @click.prevent="handleSubmit">
                OK
            </PrimaryButton>
        </div>
    </StyleHorary>
</template>

<script>
import { StyleHorary } from "./style";
import { PrimaryButton, CancelButton } from "../Styles/Extends/styled";
import { swall } from "../../services/sweetAlert";
import { mapActions } from "vuex";

export default {
    name: "HoraryDeliveryTime",
    props: {
        modal_id: {
            default: null
        },
        delivery_times: {
            default: []
        }
    },
    components: {
        StyleHorary,
        PrimaryButton,
        CancelButton
    },
    data() {
        return {
            delivery_time: null
        };
    },
    methods: {
        ...mapActions("deliveryTimes", ["setCloseModalCalendar"]),
        handleSelectDeliveryTime(delivery_time) {
            this.delivery_times.map(dt => (dt.checked = false));
            delivery_time.checked = true;
            this.delivery_time = delivery_time;
        },
        handleSubmit() {
            if (!this.delivery_time) {
                swall("Selecione um horário de entrega!");
                return;
            }

            this.$emit("handleSelectTime", this.delivery_time);
            this.setCloseModalCalendar(true);
            this.handleCancel();
        },
        handleCancel() {
            if (this.modal_id) {
                this.$root.closeModalApp(this.modal_id);
            }
        }
    }
};
</script>
